import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

/**
 * Shared Markdown preview component
 * Used for comment preview (before posting) and can be used elsewhere
 * Note: This does NOT include address detection/linking - that's handled separately in Comment.js
 */
const MarkdownPreview = ({ text, className = '' }) => {
  return (
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      components={{
        // eslint-disable-next-line jsx-a11y/heading-has-content
        h1: ({node, ...props}) => <h1 className="text-lg font-bold mt-2 mb-1" {...props} />,
        // eslint-disable-next-line jsx-a11y/heading-has-content
        h2: ({node, ...props}) => <h2 className="text-base font-bold mt-2 mb-1" {...props} />,
        // eslint-disable-next-line jsx-a11y/heading-has-content
        h3: ({node, ...props}) => <h3 className="text-sm font-semibold mt-1 mb-1" {...props} />,
        p: ({node, ...props}) => <p className="mb-2 last:mb-0" {...props} />,
        ul: ({node, ...props}) => <ul className="list-disc list-inside mb-2" {...props} />,
        ol: ({node, ...props}) => <ol className="list-decimal list-inside mb-2" {...props} />,
        li: ({node, ...props}) => <li className="mb-1 [&>p]:inline [&>p]:m-0" {...props} />,
        a: ({node, href, ...props}) => (
          // eslint-disable-next-line jsx-a11y/anchor-has-content
          <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 hover:text-blue-800 underline break-all"
            {...props}
          />
        ),
        pre: ({node, ...props}) => (
          <pre className="bg-gray-900 text-gray-100 p-4 rounded overflow-x-auto my-2" {...props} />
        ),
        code: ({node, inline, className: codeClassName, ...props}) => {
          const isBlock = node?.position?.start?.line !== node?.position?.end?.line || codeClassName?.startsWith('language-');
          if (isBlock) {
            return <code className="not-prose text-sm font-mono" {...props} />;
          }
          return <code className="not-prose bg-gray-100 px-1 py-0.5 rounded text-sm font-mono" {...props} />;
        },
        blockquote: ({node, ...props}) => (
          <blockquote className="border-l-4 border-gray-300 pl-4 italic my-2" {...props} />
        ),
      }}
    >
      {text}
    </ReactMarkdown>
  );
};

export default MarkdownPreview;
